import React from 'react';

const InputField = (props) => {
	let inputClass = 'input ' + props.validationClass;
	let helperClass = 'help ' + props.validationClass;
	return (
		<div className="field">
			<label className="label">{props.label}</label>
			<div className="control">
				<input type={props.type} onChange={props.onChange} className={inputClass} value={props.value} placeholder={props.placeholder}/>
				{ props.validationMessage && <p className={helperClass}>{props.validationMessage}</p> }
			</div>
		</div>
	)
}

export default InputField;


// WEBPACK FOOTER //
// ./src/components/input-field.jsx